module.exports = __webpack_public_path__ + "img/engravingOnTheSide.2ebef78.jpg";